import { Outlet } from 'react-router-dom';

const PronoLayout = () => {
    return <Outlet />
};

export default PronoLayout;
